import utils from '../../services/utils';

export const arlsValueLabelList = [
  { value: 'sura', label: 'Sura' },
  { value: 'mapre', label: 'Mapre' },
  { value: 'positiva', label: 'Positiva' },
  { value: 'axacolpatria', label: 'Axa Colpatria S.A.' },
  { value: 'colmena', label: 'Colmena' },
  { value: 'segurosbolivar', label: 'Seguros Bolivar S.A.' },
  { value: 'libertysegurosvida', label: 'Liberty Seguros de Vida S.A.' },
  { value: 'laequidad', label: 'La Equidad' },
  { value: 'segurosdevidaalfa', label: 'Seguros de Vida Alfa S.A.' },
  { value: 'suratep', label: 'Suratep S.A.' },
  { value: 'companiasegurosvidaaurora', label: 'Compañia de Seguros de Vida Aurora S.A.' }
];

export const arlsLabelsObject = utils.valueLabelListToLabelsObject(arlsValueLabelList);
